import React, { useState } from 'react';
import { CarIcon, TruckIcon, WrenchIcon, ChevronDownIcon, ChevronUpIcon, CheckCircleIcon, ClipboardListIcon, PhoneIcon } from 'lucide-react';
export function Services() {
  const [expandedSections, setExpandedSections] = useState<Record<string, boolean>>({});
  const toggleSection = (key: string) => {
    setExpandedSections(prev => ({
      ...prev,
      [key]: !prev[key]
    }));
  };
  return <section id="services" className="py-20 bg-white" data-id="element-8637">
      <div className="container mx-auto px-4" data-id="element-8638">
        <div className="max-w-6xl mx-auto" data-id="element-8639">
          <h2 className="text-4xl font-bold text-gray-900 mb-4 text-center" data-id="element-8640">
            Auto & Truck Repair Services
          </h2>
          <p className="text-xl text-gray-600 text-center mb-16 max-w-3xl mx-auto" data-id="element-8641">
            Expert diagnostic, repair, and maintenance services for all makes
            and models. From passenger vehicles to heavy-duty commercial trucks.
          </p>

          <div className="grid md:grid-cols-2 gap-8 mb-12" data-id="element-8642">
            {/* Automotive Services */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg border-2 border-black hover:shadow-2xl transition-all duration-300" data-id="element-8643">
              <div className="relative h-64 overflow-hidden" data-id="element-8644">
                <img src="https://cdn.magicpatterns.com/uploads/9yVbX3hih4MeQMJVSjZRxG/Automotice-Services.png" alt="Automotive repair services" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-8645" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-8646"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-8647">
                  <div className="flex items-center mb-2" data-id="element-8648">
                    <div className="bg-[#B1050B] p-2 rounded mr-3" data-id="element-8649">
                      <CarIcon size={28} className="text-white" data-id="element-8650" />
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-8651">
                      Automotive Services
                    </h3>
                  </div>
                  <p className="text-gray-200 text-sm" data-id="element-8652">
                    Complete repair and maintenance for cars, SUVs, and light
                    trucks
                  </p>
                </div>
              </div>

              <div className="bg-white p-6" data-id="element-8653">
                <p className="text-gray-700 mb-4" data-id="element-8654">
                  Expert mechanics providing comprehensive service, maintenance,
                  diagnostics, and repair for all makes and models of passenger
                  vehicles, SUVs, and light-duty trucks. From routine oil
                  changes to complex engine rebuilds.
                </p>

                <button onClick={() => toggleSection('automotive')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-medium transition-colors" data-id="element-8655">
                  {expandedSections['automotive'] ? <>
                      <ChevronUpIcon size={20} className="mr-1" data-id="element-8656" />
                      Show Less
                    </> : <>
                      <ChevronDownIcon size={20} className="mr-1" data-id="element-8657" />
                      View All Services
                    </>}
                </button>

                {expandedSections['automotive'] && <div className="mt-6 pt-6 border-t-2 border-gray-200" data-id="element-8658">
                    <div className="grid sm:grid-cols-2 gap-4" data-id="element-8659">
                      <div data-id="element-8660">
                        <ul className="space-y-2 text-gray-700" data-id="element-8661">
                          <li data-id="element-8662">• Complete diagnostic services</li>
                          <li data-id="element-8663">• Brake service and repair</li>
                          <li data-id="element-8664">• Engine repair and rebuilding</li>
                          <li data-id="element-8665">• Transmission service</li>
                          <li data-id="element-8666">• Suspension and steering</li>
                          <li data-id="element-8667">• Electrical system diagnosis</li>
                          <li data-id="element-8668">• Air conditioning service</li>
                          <li data-id="element-8669">• Heating system repair</li>
                        </ul>
                      </div>
                      <div data-id="element-8670">
                        <ul className="space-y-2 text-gray-700" data-id="element-8671">
                          <li data-id="element-8672">• Oil changes and fluid services</li>
                          <li data-id="element-8673">• Tire service and alignment</li>
                          <li data-id="element-8674">• Battery testing and replacement</li>
                          <li data-id="element-8675">• Exhaust system repair</li>
                          <li data-id="element-8676">• Cooling system service</li>
                          <li data-id="element-8677">• Fuel system service</li>
                          <li data-id="element-8678">• Preventive maintenance</li>
                          <li data-id="element-8679">• State inspections</li>
                        </ul>
                      </div>
                    </div>
                  </div>}
              </div>
            </div>

            {/* Commercial Truck Services */}
            <div className="group relative overflow-hidden rounded-lg shadow-lg border-2 border-black hover:shadow-2xl transition-all duration-300" data-id="element-8680">
              <div className="relative h-64 overflow-hidden" data-id="element-8681">
                <img src="https://cdn.magicpatterns.com/uploads/rfsCx6R5bBDAChYmGNqFwk/CommercialTruckServices.png" alt="Commercial truck repair services" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300" data-id="element-8682" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent" data-id="element-8683"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6" data-id="element-8684">
                  <div className="flex items-center mb-2" data-id="element-8685">
                    <div className="bg-[#B1050B] p-2 rounded mr-3" data-id="element-8686">
                      <TruckIcon size={28} className="text-white" data-id="element-8687" />
                    </div>
                    <h3 className="text-2xl font-bold text-white" data-id="element-8688">
                      Commercial Truck Services
                    </h3>
                  </div>
                  <p className="text-gray-200 text-sm" data-id="element-8689">
                    Specialized service for medium and heavy-duty commercial
                    vehicles
                  </p>
                </div>
              </div>

              <div className="bg-white p-6" data-id="element-8690">
                <p className="text-gray-700 mb-4" data-id="element-8691">
                  Comprehensive commercial truck repair and maintenance
                  specialists. We service all medium and heavy-duty commercial
                  vehicles, from routine maintenance to complete diagnostic and
                  repair services. Diesel and gas-powered vehicles.
                </p>

                <button onClick={() => toggleSection('commercial')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-medium transition-colors" data-id="element-8692">
                  {expandedSections['commercial'] ? <>
                      <ChevronUpIcon size={20} className="mr-1" data-id="element-8693" />
                      Show Less
                    </> : <>
                      <ChevronDownIcon size={20} className="mr-1" data-id="element-8694" />
                      View All Services
                    </>}
                </button>

                {expandedSections['commercial'] && <div className="mt-6 pt-6 border-t-2 border-gray-200" data-id="element-8695">
                    <p className="text-gray-700 mb-4" data-id="element-8696">
                      Garrett Auto & Truck Service is well known in Southeast
                      Michigan for commercial truck service. Our master
                      mechanics keep your commercial fleet rolling with expert
                      maintenance and repair.
                    </p>
                    <div className="bg-black text-white p-4 rounded border-l-4 border-[#B1050B]" data-id="element-8697">
                      <p className="font-bold text-[#B1050B] mb-2" data-id="element-8698">
                        Commercial Fleet Care Services
                      </p>
                      <p className="text-white" data-id="element-8699">
                        Specialized maintenance programs for commercial fleets.
                        Call now to get scheduled for comprehensive fleet
                        maintenance and repair.
                      </p>
                    </div>
                  </div>}
              </div>
            </div>
          </div>

          {/* Fleet Maintenance Program - Expanded Full Width */}
          <div className="bg-white rounded-lg shadow-2xl overflow-hidden border-2 border-black" data-id="element-8700">
            <div className="grid lg:grid-cols-5 gap-0" data-id="element-8701">
              <div className="lg:col-span-2 relative h-96 lg:h-auto" data-id="element-8702">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/diQWqXykJ7zyqrF7FJPm6g/Commercial-Trucks.png" alt="Commercial work truck fleet in urban setting" className="w-full h-full object-cover" data-id="element-8703" />
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-gray-900/30 to-gray-900" data-id="element-8704"></div>
              </div>

              <div className="lg:col-span-3 p-8 lg:p-10 text-gray-900" data-id="element-8705">
                <div className="flex items-center mb-6" data-id="element-8706">
                  <div className="bg-[#B1050B] p-3 rounded-lg mr-4" data-id="element-8707">
                    <WrenchIcon size={36} className="text-white" data-id="element-8708" />
                  </div>
                  <div data-id="element-8709">
                    <h3 className="text-3xl font-bold mb-1" data-id="element-8710">
                      Fleet Maintenance Program
                    </h3>
                    <p className="text-[#B1050B] font-medium" data-id="element-8711">
                      For Commercial Work Trucks & Vehicles
                    </p>
                  </div>
                </div>

                <div className="space-y-4 mb-6" data-id="element-8712">
                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-8713">
                    Many truck and fleet owners postpone simple maintenance
                    procedures because taking vehicles to a service center eats
                    up valuable man-hours. The drop-off, pickup, and retrieval
                    process costs time and productivity.
                  </p>

                  <p className="text-gray-700 text-lg leading-relaxed" data-id="element-8714">
                    <strong className="text-gray-900" data-id="element-8715">The real cost?</strong>{' '}
                    Ignoring scheduled maintenance leads to breakdowns on the
                    side of the road, extended downtime, and problems that could
                    have been prevented. We eliminate these hassles with our
                    comprehensive fleet program.
                  </p>
                </div>

                <button onClick={() => toggleSection('fleet')} className="flex items-center text-[#B1050B] hover:text-[#8A0408] font-bold text-lg transition-colors mb-6" data-id="element-8716">
                  {expandedSections['fleet'] ? <>
                      <ChevronUpIcon size={24} className="mr-2" data-id="element-8717" />
                      Show Less Details
                    </> : <>
                      <ChevronDownIcon size={24} className="mr-2" data-id="element-8718" />
                      See How We Take the Hassle Out of Maintenance
                    </>}
                </button>

                {expandedSections['fleet'] && <div className="space-y-6" data-id="element-8719">
                    {/* How It Works */}
                    <div className="bg-gray-50 p-6 rounded-lg border-2 border-gray-200" data-id="element-8720">
                      <h4 className="font-bold text-2xl text-[#B1050B] mb-4 flex items-center" data-id="element-8721">
                        <ClipboardListIcon size={24} className="mr-2" data-id="element-8722" />
                        How Our Fleet Program Works
                      </h4>
                      <div className="grid sm:grid-cols-2 gap-4" data-id="element-8723">
                        <div className="flex items-start space-x-3" data-id="element-8724">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8725" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8726">
                            We maintain your service records and D.O.T.
                            recordkeeping requirements in our state-of-the-art
                            database
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8727">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8728" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8729">
                            When it's time for service, we'll notify you in
                            advance
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8730">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8731" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8732">
                            Convenient scheduling to minimize downtime
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8733">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8734" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8735">
                            We inform you of any safety or reliability concerns
                            upfront
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8736">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8737" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8738">
                            You'll know exactly how long the vehicle will be out
                            of service
                          </p>
                        </div>
                        <div className="flex items-start space-x-3" data-id="element-8739">
                          <CheckCircleIcon size={20} className="text-[#B1050B] flex-shrink-0 mt-1" data-id="element-8740" />
                          <p className="text-gray-700 leading-relaxed" data-id="element-8741">
                            Professional service to keep your fleet running
                          </p>
                        </div>
                      </div>
                    </div>

                    {/* Services Included */}
                    <div className="bg-gray-50 p-6 rounded-lg border-2 border-gray-200" data-id="element-8742">
                      <h4 className="font-bold text-xl text-gray-900 mb-4" data-id="element-8743">
                        Fleet Maintenance Services Include:
                      </h4>
                      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-id="element-8744">
                        <div className="text-gray-700" data-id="element-8745">
                          • Oil & filter changes
                        </div>
                        <div className="text-gray-700" data-id="element-8746">
                          • Chassis lubrication
                        </div>
                        <div className="text-gray-700" data-id="element-8747">
                          • Transmission service
                        </div>
                        <div className="text-gray-700" data-id="element-8748">• Brake adjustments</div>
                        <div className="text-gray-700" data-id="element-8749">• Wheel alignment</div>
                        <div className="text-gray-700" data-id="element-8750">
                          • Cooling system maintenance
                        </div>
                        <div className="text-gray-700" data-id="element-8751">
                          • Fuel injection service
                        </div>
                        <div className="text-gray-700" data-id="element-8752">
                          • Belt & hose replacement
                        </div>
                        <div className="text-gray-700" data-id="element-8753">
                          • Clutch adjustments
                        </div>
                        <div className="text-gray-700" data-id="element-8754">
                          • Preventive diagnostics
                        </div>
                        <div className="text-gray-700" data-id="element-8755">• DOT compliance</div>
                        <div className="text-gray-700" data-id="element-8756">• And much more</div>
                      </div>
                    </div>

                    {/* Value Proposition */}
                    <div className="bg-gray-50 p-6 rounded-lg border-l-4 border-[#B1050B]" data-id="element-8757">
                      <p className="text-gray-700 text-lg leading-relaxed" data-id="element-8758">
                        <strong className="text-[#B1050B]" data-id="element-8759">
                          Garrett Auto & Truck believes in preventative
                          maintenance.
                        </strong>{' '}
                        We'll help you save time and money by providing the
                        diagnostic, repair, and replacement services recommended
                        by your vehicle manufacturer. Keep your commercial fleet
                        running reliably and avoid costly breakdowns.
                      </p>
                    </div>

                    {/* CTA */}
                    <div className="text-center pt-4" data-id="element-8760">
                      <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] text-white hover:bg-[#8A0408] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8761">
                        <PhoneIcon size={22} className="mr-2" data-id="element-8762" />
                        Call (248) 478-8382 for Fleet Service
                      </a>
                    </div>
                  </div>}

                {!expandedSections['fleet'] && <div data-id="element-8763">
                    <div className="grid sm:grid-cols-3 gap-4 mt-6" data-id="element-8764">
                      <div className="text-center p-4 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-8765">
                        <div className="text-3xl font-bold text-[#B1050B] mb-1" data-id="element-8766">
                          Easy
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-8767">Scheduling</div>
                      </div>
                      <div className="text-center p-4 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-8768">
                        <div className="text-3xl font-bold text-[#B1050B] mb-1" data-id="element-8769">
                          DOT
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-8770">
                          Record Keeping
                        </div>
                      </div>
                      <div className="text-center p-4 bg-gray-50 rounded-lg border-2 border-gray-200" data-id="element-8771">
                        <div className="text-3xl font-bold text-[#B1050B] mb-1" data-id="element-8772">
                          24/7
                        </div>
                        <div className="text-sm text-gray-600" data-id="element-8773">
                          Service Tracking
                        </div>
                      </div>
                    </div>

                    <div className="text-center mt-6" data-id="element-8774">
                      <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] text-white hover:bg-[#8A0408] px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-8775">
                        Find Out More
                      </a>
                    </div>
                  </div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}